<div class="footer-text">
  <p>
    Copyright © {{ year() }} FiniAC. All rights reserved.
    <span (click)="openHelpMenu()">Need Help?</span>
  </p>
</div>
